import React, { useRef, useState } from "react";
import "../Table/filter.scss";
import { TextField } from "@mui/material";
import ComboBox from "../ComboBox";
import filter from "../../assets/images/filter.svg";
import dropdown from "../../assets/images/dropdown.svg";

export default function MangeUserFilter({
  onApply,
  onClear,
  roleOptions,
  statusOptions,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  // NEW: keep track of what was actually applied
  const [appliedFilters, setAppliedFilters] = useState({});

  const searchFieldRef = useRef();

  const cleanFilterObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, value]) => value !== "" && value != null)
    );

  const handleApply = () => {
    const toApply = cleanFilterObject({ searchTerm, role, status });

    // store what was applied locally
    setAppliedFilters(toApply);

    // notify parent with only non-empty values
    if (typeof onApply === "function") onApply(toApply);

    // build status message
    const appliedList = [];
    if (toApply.searchTerm) appliedList.push(`Search: ${toApply.searchTerm}`);
    if (toApply.role) appliedList.push(`Role: ${toApply.role}`);
    if (toApply.status) appliedList.push(`Status: ${toApply.status}`);

    setStatusMessage(
      appliedList.length > 0
        ? `Filters applied. ${appliedList.join(", ")}.`
        : "No filters applied."
    );
  };

  const handleClear = () => {
    setSearchTerm("");
    setRole("");
    setStatus("");

    // clear local record of applied filters
    setAppliedFilters({});

    if (typeof onClear === "function") onClear();

    setStatusMessage("All filters cleared.");

    if (searchFieldRef.current) {
      // focus the search field after clearing
      searchFieldRef.current.focus();
    }
  };

  // Derived booleans
  const isAnyLocalInput = !!(searchTerm || role || status);
  const isAnyAppliedFilter = Object.keys(appliedFilters).length > 0;

  // Show Clear if either local input exists (unsaved) OR filters were applied
  const shouldShowClearButton = isAnyLocalInput || isAnyAppliedFilter;

  return (
    <div className="global-filters">
      <button
        className="filtertn-forMobile"
        onClick={() => setShowFilters((prev) => !prev)}
        aria-expanded={showFilters}
        aria-controls="globalFilterMangeuser"
      >
        <span>
          <img src={filter} alt="" />
          Filter
        </span>
        <span>
          <img
            src={dropdown}
            alt=""
            className={`drpIcon ${showFilters ? "toggleIcon" : ""}`}
          />
        </span>
      </button>

      <div
        className={`filterOptions ${showFilters ? "active" : "hidden"}`}
        id="globalFilterMangeuser"
      >
        <div className="searchWrapper">
          <TextField
            id="search-user"
            inputRef={searchFieldRef}
            placeholder="Search by Name"
            variant="outlined"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            className="innerFields serchBox"
            inputProps={{
              autoComplete: "off",
              "aria-describedby": "search-help",
              "aria-label": "Search",
            }}
          />
        </div>

        {/* <ComboBox
          label="Select Role"
          ariaLabel="Filter Role Column"
          options={roleOptions}
          value={role}
          onChange={(value) => setRole(value)}
        /> */}

        <ComboBox
          label="Select Status"
          ariaLabel="Filter Status Column"
          options={statusOptions}
          value={status}
          onChange={(value) => setStatus(value)}
        />

        <div className="clearbtns">
          <button
            className={`filter-btn applyfilterbtn ${
              isAnyLocalInput ? "activeFilterBtn" : "inactiveFilterBtn"
            }`}
            disabled={!isAnyLocalInput}
            onClick={handleApply}
          >
            Apply Filter
          </button>

          {shouldShowClearButton && (
            <button
              className={`filter-btn clearfilterbtn ${
                shouldShowClearButton
                  ? "activeclearrBtn"
                  : "inactiveclearrBtn"
              }`}
              disabled={!shouldShowClearButton}
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <div
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {statusMessage}
      </div>
    </div>
  );
}
